import { parse, getTime, isValid } from 'date-fns'

const parse_offset_date_time = (input, pattern) => {
	const replacedPattern = pattern.replace('Z', 'x');

	const result = parse(input, replacedPattern, new Date());
	
	if( isValid(result) ) {
		return getTime(result);
	} else {
		return 1 / 0; // return NaN
	}
	
}

export {
  parse_offset_date_time
}
